import React, { useState } from "react";
import Typography from "components/Typography";
import { TextField, Switch } from "components/Fields";

const CoolingUtility = ({ contractDetails, updatePropertyContract }) => {

    const [accountingStartDate, setAccountingStartDate] = useState(contractDetails.utilities.cooling.accountingStartDate ?? "");

    return (
        <>
            <Typography variant="label" className="utility-title">Køling</Typography>
            <div className="fields-section__container">
                <div className="fields-section__field">
                    <Typography variant="label">Udlejer ansvarlig</Typography>
                    <Switch
                        checked={contractDetails.utilities.cooling.isLandlordResponsible}
                        onChange={(e) => updatePropertyContract({ utilities: { cooling: { isLandlordResponsible: e.target.checked } } })}
                    />
                </div>
				<div className="fields-section__field">
                    <Typography variant="label">Lejemålet har individuelle målere</Typography>
                    <Switch
                        checked={contractDetails.utilities.cooling.hasIndividualMeters}
                        onChange={(e) => updatePropertyContract({ utilities: { cooling: { hasIndividualMeters: e.target.checked } } })}
                    />
                </div>
                <div className="fields-section__field">
                    <Typography variant="label">Kølingsregnskabsåret begynder</Typography>
                    <TextField
                        value={accountingStartDate ?? ""}
                        type="date"
                        onChange={(event) => setAccountingStartDate(event.target.value)}
                        onExit={() => setAccountingStartDate(contractDetails.utilities.cooling.accountingStartDate)}
                        onFinish={() => {
                            accountingStartDate !== contractDetails.utilities.cooling.accountingStartDate && updatePropertyContract({ utilities: { cooling: { accountingStartDate } } })
                        }}
                    />
                </div>
            </div>
            <hr/>
        </>
    );
};

export default CoolingUtility;